import React from 'react';

/**
 * Header shared by the reauthentication and the idle-warning modals: the round badge with its icon,
 * the title and the message, plus whatever the modal adds below (a countdown).
 * @param {React.ComponentType} icon - Icon drawn inside the badge.
 * @param {string} title - Already translated heading.
 * @param {string} description - Already translated message.
 * @param {string} [descriptionTestId] - Test id of the message, for modals whose message changes.
 * @author armandoricosandoval -ai-
 */
const ReauthHero = ({ icon: Icon, title, description, descriptionTestId, children }) => (
  <div className="te-reauth-hero">
    <span className="te-reauth-badge" aria-hidden="true">
      <Icon />
    </span>
    <h2 className="te-reauth-title">{title}</h2>
    <p className="te-reauth-reason" data-testid={descriptionTestId}>
      {description}
    </p>
    {children}
  </div>
);

export default ReauthHero;
